import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { formatSeconds, ConfirmDialog } from '@playbookux/playbook-web-core';
import {
  Delete,
  Description,
  DescriptionContainer,
  Dropdown,
  Icon,
  Image,
  Item as DropdownItem,
  Segment,
  Title,
  Typography,
  WatchLink,
} from './styles';

const DescriptionComponent = ({ description }) => (
  <Typography>
    <Description
      text={description}
      lines={1}
      ellipsis="..."
      buttons={false}
    />
  </Typography>
);

const Item = (props) => {
  const {
    highlightReel,
    onDelete,
    onDuplicate,
    onEdit,
    onShare,
    onView,
    onDownload,
  } = props;

  const {
    createdAt,
    createdBy,
    id: highlightReelId,
    title,
    totalClips,
    totalDuration,
  } = highlightReel;

  const [showDialog, setShowDialog] = useState(false);

  const handleClose = (evt) => {
    if (evt) {
      evt.stopPropagation();
    }
    setShowDialog(false);
  };

  const handleConfirm = (evt) => {
    evt.stopPropagation();
    handleClose();
    onDelete(highlightReelId);
  };

  const handleDelete = (evt) => {
    evt.stopPropagation();
    setShowDialog(true);
  };

  const handleEdit = (evt) => {
    evt.stopPropagation();
    onEdit(highlightReelId);
  };

  const handleDuplicate = () => {
    onDuplicate(highlightReelId);
  };

  const handleShare = (evt) => {
    evt.stopPropagation();
    onShare(highlightReel);
  };

  const handleView = () => {
    onView(highlightReelId, totalClips);
  };

  const handleDownload = (evt) => {
    evt.stopPropagation();
    onDownload(highlightReelId, totalClips);
  };

  const { profile } = createdBy;

  return (
    <Segment onClick={handleView}>
      <Dropdown
        item
        trigger={(
          <Image
            src="/images/dots-icon.png"
            alt="Playbook"
          />
        )}
      >
        <Dropdown.Menu direction="left">
          <Dropdown.Item onClick={handleEdit}>
            <DropdownItem>
              Edit
            </DropdownItem>
          </Dropdown.Item>

          <Dropdown.Item onClick={handleDuplicate}>
            <DropdownItem>
              Duplicate
            </DropdownItem>
          </Dropdown.Item>

          <Dropdown.Item onClick={handleShare}>
            <DropdownItem>Share</DropdownItem>
          </Dropdown.Item>

          <Dropdown.Item onClick={handleDownload}>
            <DropdownItem>Download</DropdownItem>
          </Dropdown.Item>

          <Dropdown.Item onClick={handleDelete}>
            <Delete>Delete</Delete>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <ConfirmDialog
        show={showDialog}
        title="Delete highlight reel"
        warning="Warning: This cannot be undone"
        confirmText="Yes, delete highlight reel"
        cancelText="Cancel, keep highlight reel"
        handleConfirm={handleConfirm}
        handleClose={handleClose}
      />

      <Title
        text={title}
        lines={1}
        ellipsis="..."
        buttons={false}
      />

      <DescriptionContainer>
        <DescriptionComponent
          description={`Created by ${profile.firstName}`}
        />

        <DescriptionComponent
          description={`Created on ${moment(createdAt).format('LL')}`}
        />

        <DescriptionComponent
          description={`${totalClips || 0} clips`}
        />

        <WatchLink>
          {`Watch ${formatSeconds(totalDuration)}`}
          <Icon name="play" />
        </WatchLink>
      </DescriptionContainer>
    </Segment>
  );
};

DescriptionComponent.propTypes = {
  description: PropTypes.string.isRequired,
};

Item.propTypes = {
  highlightReel: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default Item;
